export * from "@/ui/components/typography/TextHero/TextHero";
export * from "@/ui/components/typography/TextHero/TextHero.config";
